import { render, staticRenderFns } from "./groups-modal.vue?vue&type=template&id=023fb1cc"
import script from "./groups-modal.vue?vue&type=script&lang=js"
export * from "./groups-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports